import { Command, HttpMethod } from "~/extensions/api";
export class GetLatestBasicCommand extends Command {
    constructor(isForceGetLatest) {
        super(HttpMethod.Get, "latest/basic/get");
        this.isForceGetLatest = isForceGetLatest;
    }
    isForceGetLatest = false;
}
